import axios from "axios";
import globalConfig from "../hf_global.config";

const LOGINID = "LOGINID"; // loginid localStorage key

const baseURL = globalConfig.API_DOMAIN;

// 创建一个实例
const axiosInstance = axios.create({
  baseURL,
  withCredentials: false // 请求不要cookie
});

// request 日志
axiosInstance.interceptors.request.use(config => {
  console.log("\n\n\n请求地址：", config.method.toUpperCase(), config.url);
  console.log("请求头：", config.headers);
  console.log("请求参数：", config.data || config.params);
  const loginid = localStorage.getItem(LOGINID);
  if (loginid) {
    console.log("当前请求携带cookie：", loginid);
    config.headers["loginid"] = loginid;
  }
  return config;
});

// response 日志
axiosInstance.interceptors.response.use(resp => {
  console.log("请求响应：", resp);
  // 如果返回res存在cookie login字段，下一次请求带过去
  if (resp.headers && resp.headers.loginid) {
    console.log(resp.config.url, "设置loginid");
    const loginid = resp.headers.loginid;
    localStorage.setItem(LOGINID, loginid);
  }
  const { data } = resp;
  if (data) {
    return data;
  }
  return resp;
});

export default axiosInstance;
